import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { I18nModule } from '@recruitee/i18n';

import { ButtonModule } from '../../common/button/button.module';
import { HeadingModule } from '../../common/heading/heading.module';
import { IconModule } from '../../common/icon/icon.module';
import { DialogBodyModule } from '../../dialog/dialog-body/dialog-body.module';
import { IllustrationDialogComponent } from './illustration-dialog.component';

@NgModule({
  declarations: [IllustrationDialogComponent],
  imports: [
    RouterModule,
    CommonModule,
    DialogBodyModule,
    ButtonModule,
    IconModule,
    I18nModule,

    HeadingModule,
  ],
})
export class IllustrationDialogModule {}
export {
  IllustrationDialogComponent,
  IllustrationDialogData,
} from './illustration-dialog.component';
